import React from "react";
import coinIcon from "../../../assets/images/svg/portfolioModal.svg";
import ArrowBtn from "../../../components/ArrowButton";
import { commaSeperated, displayUnit } from "../../../utils/functions";

const TotalPortfolioModal = ({ title, data, onClose, titleKey }) => {
  return (
    <div className="total_portfolio_modal">
      <div className="flex is-align-items-center title_container">
        <div>
          <img src={coinIcon} alt="a" />
        </div>
        <div className="title">{title}</div>
      </div>
      <div>
        {data.map((value, index) => {
          return (
            <div
              key={index}
              className="flex cash_item is-justify-content-space-between"
            >
              <p className="label">{value?.type || value?.name}</p>
              <p className="value">
                <span className="values">
                  {value?.amount?.value
                    ? commaSeperated(value?.amount?.value)
                    : value.amt?.value
                    ? commaSeperated(value.amt?.value)
                    : ""}
                </span>
                <span className="unit">
                  {titleKey?.name?.includes("Unutilised Cash")
                    ? " " + displayUnit(value?.amount?.value_type)
                    : " " + displayUnit(value?.amt?.value_type)}{" "}
                </span>
              </p>
            </div>
          );
        })}
      </div>
      <div
        className="flex is-justify-content-flex-end arrow_btn_wrapper"
        onClick={onClose}
      >
        <ArrowBtn type="next" label="Got it" />
      </div>
    </div>
  );
};

export default TotalPortfolioModal;
